import { render, staticRenderFns } from "./AllOrdersView.vue?vue&type=template&id=4df10dfb"
import script from "./AllOrdersView.vue?vue&type=script&lang=js"
export * from "./AllOrdersView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports